import React from 'react'

import type { IconComponent } from '@fourthwall/components'
import { ButtonClean, Icon } from '@fourthwall/components'
import { CloseIcon, QuestionIcon, TickIcon } from '@fourthwall/icons'

import type { ProductsSyncStatus } from '../../AppsTiktokShop.types'
import * as S from './ProductsSyncStatusHeading.styled'

export type ProductsSyncStatusHeadingProps = {
  status: ProductsSyncStatus
  label: string
  onSeeDetails?: () => void
}

const statusIcon: Record<ProductsSyncStatus, IconComponent> = {
  active: TickIcon,
  pending: QuestionIcon,
  denied: CloseIcon,
}

export const ProductsSyncStatusHeading = ({
  status,
  label,
  onSeeDetails,
}: ProductsSyncStatusHeadingProps) => (
  <S.Container>
    <S.IconContainer>
      <S.Icon status={status}>
        <Icon component={statusIcon[status]} height={10} />
      </S.Icon>
    </S.IconContainer>
    <S.Label>{label}</S.Label>
    {onSeeDetails && (
      <S.ButtonContainer>
        <ButtonClean label="See details" onClick={onSeeDetails} />
      </S.ButtonContainer>
    )}
  </S.Container>
)
